const translationJsonObj = require('libs-content-helper').EsTranslations;

var translationJson = {
  "SHARED": {
    "_COMMON_ACROSS_PAGES": {
      "HEADER": {
        "MY_PROFILE": "Mi perfil",
        "LOGOUT": "Cerrar sesión",
        "SCREEN_READER": {
          "CAMBRDIGE_LOGO": "Cambridge One Home"
        }
      },
      "FOOTER": {
        "TERMS_OF_USE": "Términos de uso",
        "PRIVACY_POLICY": "Aviso de privacidad",
        "ACCESSIBILITY": "Accesibilidad",
        "OUR_APPROACH": "Our approach",
        "HELP": "Ayuda",
        "CAMBRDIGE_UNIVERSITY_PRESS": "Cambridge University Press & Assessment",
        "INSTITUTION_REQUEST": "Cambridge One para centros educativos",
        "FAQ": "FAQs"
      },
      "COOKIES_BANNER": {
        "WEBSITE_USES_COOKIES": "Este sitio web utiliza cookies. Para más información, consulta",
        "PRIVACY_POLICY": "Aviso de privacidad",
        "ACCEPT": "Acepto cookies"
      }
    },
    "CHANGES_NOT_SAVED": {
      "FORGIVE_US_TEXT": "Lamentablemente,",
      "SORRY_SOMETHING_WRONG_TEXT": "Lamentablemente, algo salió mal",
      "SORRY_PROBLEM_AT_OUR_END_TEXT": "Lamentablemente hubo un problema en nuestra plataforma. Vuelve a intentar más tarde",
      "SOMETHING_WENT_WRONG": "no podemos entregar tu trabajo en este momento.",
      "LAST_SAVED": "Última vez guardado",
      "PLEASE_TRY_AGAIN": "Verifica que estás en línea y vuelve a intentar",
      "OK": "OK",
      "RECORDING_NOT_SAVED": "Lamentablemente, no podemos guardar tu trabajo en este momento. No te preocupes; no perderás tu trabajo a menos que hagas click en el botón de Salir.",
      "CHECK_TIPS": "Intenta lo siguiente",
      "FREE_SPACE": "Verifica que estás en línea.",
      "TIPS2": "Haz espacio en tu dispositivo.",
      "PLEASE_CHECK_URL_LINK": "Verifica el URL agregado y vuelve a intentar"
    },
    "SAVEALERT": {
      "CLOSE": "Cerrar",
      "EXIT": "Sí, quiero salir de esta página",
      "STAY": "Permanecer en esta página",
      "LOOSE_WORK_WARNING_MESSAGE": "Si lo haces, perderás todo tu trabajo",
      "ARE_YOU_SURE": "¿Estás seguro de querer abandonar esta actividad?"
    },
    "COLLAB" : {
      "SHOW_INSTRUCTION": "Mostrar instrucciones",
      "HIDE_INSTRUCTIONS": "Ocultar instrucciones",
      "READY": "Listo",
      "SUBMIT": "Enviar",
      "ARE_YOU_READY_TO_SUBMIT": "¿Listo para entregar?",
      "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "Estás actuando en nombre de todos los integrantes del grupo. ¿Estás seguro de que esta actividad ya está completa?",
      "CANCEL": "Cancelar",
      "COMPLETE": "Sí, completa",
      "TITLE" : "Tarea colaborativa",
      "MODAL_PLACEHOLDER" : "Esta es una tarea colaborativa en la que los alumnos asignados a un grupo trabajan juntos para completar una actividad. Para hacerlo, los alumnos deben formar parte de un grupo .",
      "DISABLE_GROUP_INFO_MSG" : "Esta es una actividad colaborativa. Solo pueden completarla alumnos asignados a grupos por un profesor.",
      "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado, pero todavía puedes ver los comentarios del grupo.",
      "ARCHIVED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado.",
      "POST_BUTTON" : "Publicar",
      "NO_COMMENTS_LABEL": "Ningún comentario aún",
      "YOUR_COMMENT_LABEL": "Tu comentario",
      "LOAD_MORE_COMMENTS": "Ver comentarios anteriores",
      "LOADING_COMMENTS": "Cargando",
      "ACTOR_TEACHER_LABEL": "Profesor",
      "ELAPSED_TIME": {
           "JUST_NOW": "Recién",
           "MINUTE_AGO": "hace 1 minuto",
           "MINUTES_AGO": "hace X minutos",
           "HOUR_AGO": "hace 1 hora",
           "HOURS_AGO": "hace X horas",
           "DAY_AGO": "hace 1 día",
           "DAYS_AGO": "hace X días"
      },
      "SCREEN_READER": {
          "GROUP_INFO": "Información sobre el grupo",
          "CLOSE_GROUP_INFO": "Cerrar ventana emergente de información sobre el grupo",
          "SCROLL_BTN_UP": "Desplazar al tope",
          "SCROLL_BTN_DOWN": "Desplazar al pie",
          "CROSS": "Cerrar",
          "HELP": "Ayuda"
      }
    },
    "PRODUCT_VIEW": {
        "BACK": "Atrás",
        "UNIT_STATUS_COMPLETED": "Completado",
        "UNIT_STATUS_IN_PROGRESS": "En desarrollo",
        "SCREEN_READER": {
          "CLOSE_POPUP": "Close popup",
          "LOCKED": "bloqueado",
          "PROGRESS_BAR": " ,barra de progreso ",
          "PERCENT": " por ciento"
        },
        "ASSIGNMENTS_ONLY_BANNER": {
          "DESC": "This material can only be completed by students when you unlock or assign it",
          "DONT_SHOW_AGAIN": "Don't show again",
          "CLOSE": "Close"
        }
    },
    "RESULT_SCREEN": {
      "YOU_SCORED": "Tu puntaje fue",
      "MARKS_OUT_OF": "de",
      "CONTINUE": "Actividad siguiente",
      "REVIEW": "Revisar respuestas",
      "TRY_AGAIN": "Vuelve a intentar",
      "START_AGAIN": "Vuelve a intentar"
    },
    "ACTIVITY_RENDERER": {
      "SCREEN_READER": {
          "ACTIVITY": "Actividad: {{activityName}}"

        }
    },
    "AUDIO_PROMPT": {
      "FORWARD_BUTTON": "Avanzar 5 segundos",
      "REWIND_BUTTON": "Retroceder 5 segundos",
      "PLAY": "Reproducir",
      "PAUSE": "Pausar",
      "SCREEN_READER": {
          "PROGRESS_BAR": "Seek"
      }
    },
    "CONTENT_ACCESS": {
      "RULE": {
        "CONTENT_LOCKED": "Contenido bloqueado",
        "NO_ACCESS": "No tienes acceso a esta actividad",
        "NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT": "Este contenido te estará disponible cuando tu profesor te dé acceso",
        "TIME_RANGE_START": "Te volverá a estar disponible desde el <strong>{{startDate}} {{startTime}}</strong>",
        "TIME_RANGE_END": "hasta el <strong>{{endDate}} {{endTime}}</strong>",
        "GO_BACK": "Atrás"
      }
    }
  },
  "HTML_META": {
    "MAIN" : {
      "CUSTOM_TITLE" : " | Cambridge One",
      "TITLE" : "Cambridge One | Cambridge University Press",
      "DESCRIPTION" : "Cambridge One es una plataforma de aprendizaje compatible con dispositivos móviles para estudiantes y docentes del idioma inglés."
    }
  },
  "TEACHER": {
    "ACTIVITYVIEW": {
        "_url": ":spaceid/product/:productcode/view/item/:itemid",
        "DOWNLOAD_INSTRUCTIONS1": "Descarga el/la",
        "DOWNLOAD_INSTRUCTIONS2": "a continuación y completa esta actividad",
        "DOWNLOAD": "Descargar",
        "SUBMITTED_FOR_MARKING": "Entregado/a",
        "FEEDBACK_READY_MSG": "Te avisaremos cuando tu profesor haya calificado tu trabajo",
        "SUBMITTED": "Entregado/a",
        "ARE_YOU_READY_TO_SUBMIT": "¿Listo para entregar?",
        "ARE_YOU_READY_TO_SUBMIT_GROUP": "¿Listo para entregar el trabajo de tu grupo?",
        "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "No olvides que, una vez entregado, ya no podrás implementar ningún cambio en tu trabajo",
        "NO_FURTHER_CHANGES_ALLOWED_MESSAGE_GROUP": "Estás actuando en nombre de todos los integrantes del grupo. Ya no podrás implementar ningún cambio en el trabajo a menos que el profesor lo pida.",
        "CANCEL": "Cancelar",
        "SUBMIT": "Enviar",
        "YES_SUBMIT": "Sí, entregar",
        "CLASS_NOT_STARTED_MSG": "Tu clase aún no ha comenzado",
        "SAVE_DRAFT_AFTER_CLASS_STARTS": "Puedes guardar un borrador ahora y enviarlo a tu profesor cuando comience la clase",
        "SAVE": "Guardar",
        "SAVED": "Guardado",
        "AUTO_SAVED": "Guardado automáticamente",
        "COMPLETED": "Completado/a",
        "START_RECORDING_MSG1": "Tocar para comenzar a grabar",
        "START_RECORDING_MSG2": "Podrás reproducirlo una vez que se haya detenido",
        "PLAY_RECORDING_MSG1": "Reproducir la grabación",
        "PLAY_RECORDING_MSG2": "Tiempo de grabación: {{elapsedTime}}",
        "STOP_PLAYING_MSG1": "Parar la reproducción",
        "STOP_PLAYING_MSG2": "Tiempo: {{audioSeeker}}/{{duration}}",
        "START_NEW_RECORDING_MSG1": "Iniciar una grabación nueva",
        "START_NEW_RECORDING_MSG2": "Reemplazará a la anterior",
        "RECORDING": "Grabando",
        "STOP_RECORDING_MSG1": "Parar la grabación",
        "STOP_RECORDING_MSG2": "Tiempo transcurrido: {{elapsedTime}}",
        "SEC_LEFT": " segundos restantes",
        "SUBMITTING_MSG1": "Enviando grabación ...",
        "SAVING_MSG1": "Guardando grabación ...",
        "PROCESSING_MSG": "Processing recording ...",
        "SUBMITTED_RECORDING": "Reproducir la grabación",
        "RECORDED": "Grabando",
        "FORGIVE_US_TEXT_MSG1": "Lamentablemente,",
        "RECORDING_NOT_POSSIBLE_MSG1": "no podemos grabar tu trabajo en este momento",
        "RECORDING_NOT_POSSIBLE_MSG2": "Puede deberse a que no estás en línea, a que tu micrófono no está conectado, o a que tu navegador no permite la grabación. Verifica que estás en línea, y que tu micrófono está prendido, o intenta nuevamente utilizando un navegador diferente (sugerimos Chrome, Firefox o Safari), y/o un dispositivo diferente (tablet o PC de escritorio).",
        "OK": "OK",
        "NEXT": "Próximo",
        "CHECK": "Verificar",
        "PREVIOUS": "Previous",
        "FIRST_ATTEMPT":"Primer intento:",
        "SECOND_ATTEMPT":"Segundo intento:",
        "THIRD_ATTEMPT":"Tercer intento:",
        "SCORE":"Puntaje:",
        "NO_FEEDBACK": "Sin observaciones:",
        "MARKED_AT": "{{elapsedTime}} hasta {{timestamp}} marcado",
        "MARK" : "Puntaje:",
        "FEEDBACK" : "Comentarios:",
        "NEW_SUBMISSION_REQUESTED": "Nueva entrega solicitada",
        "WORDS": "palabras",
        "WORD_COUNT": "Recuento de palabras:",
        "ANSWER": "Respuesta:",
        "ANSWER_LABEL": "Respuesta",
        "TITLE" : "Tarea colaborativa",
        "MODAL_PLACEHOLDER" : "Esta es una tarea colaborativa en la que los alumnos asignados a un grupo trabajan juntos para completar una actividad. Para hacerlo, los alumnos deben formar parte de un grupo .",
        "DISABLE_GROUP_INFO_MSG" : "Esta es una actividad colaborativa. Solo pueden completarla alumnos asignados a grupos por un profesor.",
        "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado, pero todavía pueden verse los comentarios del grupo.",
        "ARCHIVED_LOCK_VERSION_MSG" : "Esta actividad está bloqueada porque el grupo que trabajó en ella ahora está archivado.",
        "TYPE_HERE": "Escribe aquí...",
        "NEXT_ACTIVITY": "ACTIVIDAD SIGUIENTE",
        "REVIEW": "CRÍTICA",
        "BACK": "ATRÁS",
        "ON_BEHALF_OF": "en nombre de",
        "ON_BEHALF_OF_STUDENT_NOT_PRESENT": "Un alumno que no forma parte del grupo entregó en nombre de",
        "GROUP_PSKILL_TITLE": "Title:",
        "ADD_LINK": "Add link",
        "EDIT_LINK": "Edit link",
        "REMOVE_LINK": "Remove link",
        "URL": "URL",
        "URL_PLACEHOLDER": "Enter the destination link",
        "URL_REQUIRED": "URL is required",
        "URL_INVALID": "Enter a valid URL",
        "URL_HELP_TEXT": "(max 256 characters are allowed)",
        "OPTIONAL_TEXT": "Text to display (optional)",
        "OPTIONAL_TEXT_PLACEHOLDER": "Enter the text to display",
        "UPDATE_LINK": "Edit link",
        "ARE_YOU_SURE": "Are you sure?",
        "LINK_WILL_REMOVED": "The link will be removed.",
        "KEEP_LINK": "Keep",
        "CONFIRM_LINK_DELETE": "Yes, delete",
        "PRODUCTIVESKILL_SUBMIT_DISABLE_TOOLTIP": "You will be able to submit this activity when a teacher is added to your class",
        "SCREEN_READER": {
            "CROSS": "Cerrar",
            "HELP": "Ayuda",
            "ACTIVITY_IN_PROGRESS": "Estado de actividad: en desarrollo",
            "SUBMIT_ANSWERS_FOR_MARKING": "Enviar",
            "GOTO_NEXT_SCREEN": "Pasar a la pantalla siguiente",
            "GO_TO_UNIT_VIEW": "Ir a vista de unidad",
            "CLOSE_TOC": "Cerrar tabla de contenido",
            "ACTIVITY_COMPLETED_ABOVE_THRESHOLD": "Estado de actividad: completada con puntaje superior al objetivo",
            "ACTIVITY_COMPLETED_BELOW_THRESHOLD": "Estado de actividad: completada con puntaje inferior al objetivo",
            "OPEN_TOC": "Abrir tabla de contenido",
            "DOWNLOADABLE_ITEM": "Esto puede descargarse",
            "BOLD": "Negrita",
            "ITALIC": "Bastardilla",
            "UNDERLINE": "Subrayar",
            "OPEN_LINK": "Open link: ",
            "SHOW_LINK_OPTIONS": "Show link options",
            "CANCEL_DELETE_LINK": "Cancel link deletion",
            "ACTIVITY_SCREEN_STATUS": "Exercise {{currentScreen}} of {{totalScreens}}"
        }
    },
    "GROUPSELECTON": {
      "SELECT_GROUP" : "Seleccionar grupo",
      "NO_GROUP" : "No se encontró ningún grupo",
      "ARCHIVED_GROUPS": "Grupos archivados",
      "GROUP_SORT_OLDEST_FIRST": "Fecha (Primero la más antigua)",
      "GROUP_SORT_NEWEST_FIRST": "Fecha (Primero la más nueva)",
      "GROUP_SORT_BY": "Clasificar según: "
    },
    "PRODUCT_VIEW": {
      "BANNER_MESSAGE": "{{activatedProductTitles}} for {{bundleTitle}} activated",
      "PEAS_BANNER_MESSAGE": "{{peasBundleTitle}} activated"
    }
  },
  "LEARNER": {
        "CREATE_USER_ANALYTICS": {
            "WELCOME_TEXT": "Welcome to your Cambridge One",
            "DESCRIPTION_TEXT": "We’re setting up the learning materials for you",
        },
    }
}
module.exports = Object.assign(translationJsonObj, translationJson);
